import { formatDate } from '@angular/common';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { Component, ViewChild } from '@angular/core';
import { SVGIcon, filePdfIcon, fileExcelIcon } from '@progress/kendo-svg-icons';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import Swal from 'sweetalert2';
import { RemoveEvent } from '@progress/kendo-angular-upload';

import {
  SelectableSettings,
  SelectableMode,
} from '@progress/kendo-angular-grid';
import {
  orderBy,
  SortDescriptor,
  filterBy,
  CompositeFilterDescriptor,
  FilterDescriptor,
} from '@progress/kendo-data-query';
import {
  FormArray,
  FormControl,
  FormGroup,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';

import {
  FilterableSettings,
  DataBindingDirective,
  GridDataResult,
  PageChangeEvent,
  DataStateChangeEvent,
  GridComponent,
} from '@progress/kendo-angular-grid';
import { Subscription } from 'rxjs';

import { Router } from '@angular/router';
import { Store, compose, select } from '@ngrx/store';
import { LoaderService } from '../../../core/services/loader.service';
import {
  createInvoiceResponse,
  deleteInvoiceResponse,
  getAllBillinvloiceResponse,
  getBillinvloiceResponse,
  updateInvoiceResponse,
} from '../../../store/billsSettings/billSettings-selector';
import {
  createInvoice,
  deleteInvoice,
  getAllBillinvloicelist1,
  getBillinvloicelist1,
  resetInvoiceListState,
  resetInvoiceState,
  updateInvoice,
} from '../../../store/billsSettings/billSettings.action';
import { SharedService } from '../../../shared/shared.service';
import { Validations } from '../../../shared/constants/validations';
import { FileRestrictions } from '@progress/kendo-angular-upload';
import { process, State } from '@progress/kendo-data-query';
import {
  slop_position,
  table_pageSize,
} from '../../../shared/constants/templatesNames';
import { Helper } from '../../../core/helpers/helper';
import { FileInfo } from '@progress/kendo-angular-upload';
import { PdfexportService } from '../../../core/services/pdfexport.service';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { SweetAlertIcon } from '../../../shared/constants/enum';
import _ from 'lodash';
import { PaymentLinkService } from '../../../core/services/paymentLink.service';
import {
  getAllPaymentlinksListExport,
  getPaymentLink,
  resetPaymentlinksDetailsState,
} from '../../../store/paymentlinks/paymentlinks.action';
import {
  getallpaymentlinkExportResponse,
  getpaymentLinkResponse,
} from '../../../store/paymentlinks/paymentlinks-selector';
import { NotificationService } from '../../../shared/notification.service';
@Component({
  selector: 'app-payment-links',
  templateUrl: './payment-links.component.html',
  styleUrl: './payment-links.component.scss',
  standalone: false,
})
export class RpPaymentLinksComponent {
  myRestrictions: FileRestrictions = {
    allowedExtensions: ['.jpg', '.png'],
  };
  datePickerConfig: Partial<BsDatepickerConfig>;
  public mySelection: any = [];
  addpaymentLinkForm!: UntypedFormGroup;
  flatList: any = [];
  public fileImages: Array<FileInfo> | undefined;
  public selectableSettings!: SelectableSettings;
  public checkboxOnly = true;
  public drag = false;
  public mode: SelectableMode = 'multiple';
  orderByQuery: string = '';
  queryString: string = '';
  uploadSaveUrl = 'saveUrl'; // should represent an actual API endpoint
  uploadRemoveUrl = 'removeUrl'; // should represent an actual API endpoint
  invoicesearchedValue = '';
  @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective | undefined;
  public billsInvoice: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };
  regexp = /^(?!0\d)\d+(\.\d{1,2})?$/;
  consumerList: any = [];
  public paymentLinkgridData: GridDataResult = { data: [], total: 0 };
  paymentlinksDataList: any[] = [];
  paymentLinkDataListtotalCount: number = 0;

  public pageSize = 10;
  public skip = 0;

  PaymentLinksValidations = Validations;
  public pageSizes = table_pageSize.pageSizes;
  public slop_position = slop_position;
  modelRef_1!: BsModalRef;
  invoiceAdd!: BsModalRef;

  isAllOpen: boolean = true;
  public filterMode: FilterableSettings = 'row';
  public filePdfIcon: SVGIcon = filePdfIcon;
  public fileExcelIcon: SVGIcon = fileExcelIcon;
  url: any = '';
  hidden!: boolean;
  public sort: SortDescriptor[] = [];
  public filter: CompositeFilterDescriptor = { logic: 'and', filters: [] };

  modalRef!: BsModalRef;
  config: any = {
    backdrop: true,
    ignoreBackdropClick: true,
  };
  public billpageSizes = true;
  public billpreviousNext = true;

  public buttonCount = 5;
  public info = true;
  public type: 'numeric' | 'input' = 'numeric';

  submitted: boolean = false;
  optionalSubmitted: boolean = false;
  individualbillSubmitted: boolean = false;
  searchedValue: any = '';
  configData: any;
  utilityList: any[] = [];

  selectedUtilityType: any[] = [];
  regex = /^[0-9]*$/;
  gstregex: RegExp = /^(1?[0-9]|2[0-8])$/;

  regex_Alphanumeric = /^[a-zA-Z0-9]*$/; //Only Alpha numeric are allowed
  NumberWithDecimalregex: RegExp = /^\d+(\.\d+)?$/;
  Onlynumberwithdecimals = /^\d+(\.\d+)?$/; //Only number with decimals

  @ViewChild('dp', { static: true }) datePicker: any;

  @ViewChild('pdfGrid') public hiddenGrid: GridComponent | undefined;
  @ViewChild(DataBindingDirective) dataBinding!: DataBindingDirective;
  billGenType?: string;
  billAllInvoiceList: any[] = [];
  breadCrumbItems: Array<{}> | undefined;
  allPaymentLinkData: any = [];
  currentUserData: any;
  max_amount: any;
  min_amount: any;
  projectId: any;
  constructor(
    private modalService: BsModalService,
    private sharedService: SharedService,
    private paymentLinkService: PaymentLinkService,
    private router: Router,
    private notificationService: NotificationService,
    private store: Store,
    private loaderService: LoaderService,
    private formBuilder: UntypedFormBuilder,
    private PdfexportService: PdfexportService
  ) {
    this.breadCrumbItems = [{ label: 'Payment Links' }];
    this.datePickerConfig = {
      dateInputFormat: 'DD-MM-YYYY', // Set the format to dd-mm-yyyy
      isAnimated: true, // Optional: add animation
      showWeekNumbers: false, // Optional: hide week numbers
      minDate: new Date(),
    };
    this.selectableSettings = {
      checkboxOnly: this.checkboxOnly,
      mode: this.mode,
      drag: this.drag,
    };
    const currentUserString = localStorage.getItem('currentUser');
    this.currentUserData = JSON.parse(currentUserString ?? '');
    this.max_amount = this.currentUserData?.project?.maxRechargeAmount;
    this.min_amount = this.currentUserData?.project?.minRechargeAmount;
    this.addpaymentLinkForm = this.formBuilder.group({
      consumerId: ['', [Validators.required]],
      contactNumber: ['', [Validators.required]],
      email: ['', [Validators.required]],
      rechargeamt: [
        '',
        [
          Validators.pattern(this.regexp),
          Validators.required,
          Validators.max(this.max_amount),
          Validators.min(this.min_amount),
        ],
      ],
      consumerName: [''],
      flatNo: [null],
    });

    this.getAllConfigData();
    this.getInvoiceStoreInfo();
  }
  closeModel() {
    this.flatList = [];
    this.invoiceAdd?.hide();
  }
  selectionUser(user: any): void {
    if (user && user.name) {
      this.flatList = user?.flatNos;
      this.addpaymentLinkForm.patchValue({
        contactNumber: user.phoneNo || '',
        email: user.email || '',
        consumerName: user.name || '',
        flatNo: user.flatNo || null,
      });
    } else {
      this.flatList = [];
      this.addpaymentLinkForm.reset(); // Fully resets the form
    }
  }

  public showTooltip(e: MouseEvent): void {
    const element = e.target as HTMLElement;

    // Check if the element is a table cell
    if (element.nodeName === 'TD') {
      const cellValue = element.innerText.trim();

      // Only show the tooltip if the cell is not empty, null, or ''
      if (cellValue && !element.closest('.no-tooltip')) {
        this.tooltipDir?.toggle(element);
      } else {
        this.tooltipDir?.hide();
      }
    } else if (element.classList.contains('k-column-title')) {
      this.tooltipDir?.toggle(element);
    } else {
      this.tooltipDir?.hide();
    }
  }
  getAllConfigData() {
    let payload = ['utilities'];
    this.sharedService.getAllConfigData(payload).subscribe((data) => {
      if (
        data.statusCode == 200 &&
        data.message == 'Config data retrieved successfully.'
      ) {
        this.configData = data.data;
        this.utilityList = this.configData.utilities;
      }
    });
  }

  getAllProjectConsumers() {
    this.addpaymentLinkForm.get('contactNumber')?.disable();
    this.addpaymentLinkForm.get('email')?.disable();
    // this.addpaymentLinkForm.get('flatNo')?.disable();
    this.paymentLinkService
      .getProjectConsumers(this.currentUserData?.project?.id)
      .subscribe((data) => {
        if (data.statusCode == 200) {
          this.consumerList = data.data;
        }
      });
  }

  isUploading: boolean = false;

  get addPaymentlinksFormControls() {
    return this.addpaymentLinkForm.controls;
  }
  public onUpload(): void {
    this.isUploading = true;
  }

  public onSuccess(): void {
    this.isUploading = false;
  }
  private exportSubscription: Subscription = new Subscription();
  getInvoiceStoreInfo() {
    let getInvoiceAds$ = this.store.pipe(select(getpaymentLinkResponse));

    this.exportSubscription = this.store
      .pipe(select(getallpaymentlinkExportResponse))
      .subscribe((res: any) => {
        if (res) {
          this.allPaymentLinkData = [];
          if (res.items.length > 0) {
            this.allPaymentLinkData = [...res.items];

            const transformedData = this.allPaymentLinkData.map(
              (item: any) => ({
                'Consumer Name': item.consumerName,
                'Mobile Number': item.phoneNo,
                Email: item.email,
                Amount: item.amount,
                'Flat No': item.flatNo,
                'Payment Link': item.paymentLink,
                'Generated Date': this.sharedService.dateFormateChnage(
                  item.createdOn
                ),
                'Payment ID': item.paymentId,
                'Order ID': item.orderId,
                'Payment Link ID': item.paymentLinkId,
                'Payment Link Expiry Date': this.sharedService.dateFormateChnage(
                  item.paymentLinkExpDate
                ),

                'Payment Date': item.paymentDate
                  ? this.sharedService.dateFormateChnage(item.paymentDate)
                  : '-',
                'Payment Status': item.paymentStatus,
              })
            );

            this.PdfexportService.downloadExcel(
              transformedData,
              'Payment Links'
            );
          } else {
            this.sharedService.showMessageDialog(
              'No data to display',
              '',
              SweetAlertIcon.ERROR
            );
          }
        }
      });

    getInvoiceAds$.subscribe((res: any) => {
      console.log(res);
      if (res) {
        this.loaderService.setLoading(false);
        this.paymentlinksDataList = [...res.items];
        console.log(this.paymentlinksDataList);
        this.pageSize = res.pageSize;
        this.paymentLinkDataListtotalCount = res.totalCount;
        this.loadBillsInvoiceGridTable();
      }
      console.log('billSettingList', res, this.paymentlinksDataList);
    });
  }

  ngOnDestroy() {
    this.store.dispatch(resetPaymentlinksDetailsState());
    this.exportSubscription.unsubscribe(); // Or set it to [] if you prefer an empty array
  }

  loadBillsInvoiceGridTable() {
    const state: any = {
      take: this.pageSize,
      sort: this.sort,
      filter: this.filter,
    };
    const processedData = process(this.paymentlinksDataList, state);
    this.paymentLinkgridData = {
      data: this.paymentlinksDataList,
      total: this.paymentLinkDataListtotalCount,
    };

    this.paymentLinkgridData.data = this.paymentLinkgridData.data.map(
      (invoice) => {
        console.log(new Date(invoice.date));
        return {
          ...invoice,
          from: invoice.from
            ? this.sharedService.dateFormateChnage(invoice.from)
            : '-',
          to: invoice.to
            ? this.sharedService.dateFormateChnage(invoice.to)
            : '-',
          createdOn: invoice.createdOn
            ? this.sharedService.dateFormateChnage(invoice.createdOn)
            : '-',
          paymentLink_ExpDate: invoice.paymentLinkExpDate
            ? this.sharedService.dateFormateChnage(invoice.paymentLinkExpDate)
            : '-',
          payment_Date: invoice.paymentDate
            ? this.sharedService.dateFormateChnage(invoice.paymentDate)
            : '-',
        };
      }
    );
    // this.paymentLinkgridData = {
    //   data: this.paymentlinksDataList.map((item: any) => {
    //     return {
    //       ...item,
    //       // Add 'fileUrl' for each item (custom logic here for the URL)
    //       fileImg: item.fileUrl?this.convertImageToBase64(item.fileUrl):'' // Assuming you have a method to generate the file URL
    //     };
    //   }),
    //   total: this.paymentLinkDataListtotalCount,
    // };
    console.log(this.paymentLinkgridData);
    // this.loaderService.setLoading(false);
  }

  private files: any[] = [];
  onSelectFile(event: any) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      // this.file = event.target.files[0]
      var fromdate = new FormData();
      //this.addpaymentLinkForm.patchValue({ image: this.file });
      // fromdate.append('file', file);

      reader.readAsDataURL(event.target.files[0]); // read file as data url

      reader.onload = (event) => {
        // called once readAsDataURL is completed
        this.url = event?.target?.result;
        console.log(this.url);
      };
    }
  }
  onFilter(value: any) {
    this.triggerSearch();
   /*  this.invoicePageChange({ skip: 0, take: this.pageSize });
    this.getPaymentLinksList(); */
  }
  deleteInvoice() {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-primary ms-2',
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        showCancelButton: true,
      })
      .then((result) => {
        if (result.value) {
          swalWithBootstrapButtons.fire(
            'Deleted!',
            'Your file has been deleted.',
            'success'
          );
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          swalWithBootstrapButtons.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  utilityChange(event: any) {
    console.log(event);
  }
  /**
   * Advertisment modal
   * @param addAdvertismentModal Advertisment modal data
   */
  showAdvertismentModal(addAdvertismentModal: any) {
    this.modalRef = this.modalService.show(addAdvertismentModal);
  }

  /**
   * Charge modal
   * @param addChargeModal Advertisment modal data
   */
  showChargeModal(addChargeModal: any) {
    this.modalRef = this.modalService.show(addChargeModal);
  }

  ngOnInit(): void {
    this.notificationService.emitNotificationUpdate();
    this.getAllProjectConsumers();
    this.getPaymentLinksList();
  }
  public onValueChange(ev: string): void {
    const trimmedValue = ev.trim();

    // If user enters only spaces — do nothing (just keep the clear icon visible)
    if (trimmedValue.length === 0 && ev.length > 0) {
      return;
    }

    // If user cleared the box (either manually or by clicking the clear icon)
    if (ev.length === 0) {
      this.invoicePageChange({ skip: 0, take: this.pageSize });
      //  this.getUsersData();
    }
    /*  if (ev.length == 0) {
      this.invoicePageChange({ skip: 0, take: this.pageSize });
      this.getPaymentLinksList();
    } */
  }
  private triggerSearch(): void {
    const trimmedValue = this.invoicesearchedValue.trim();

    // If only spaces — do nothing
    if (trimmedValue.length === 0 && this.invoicesearchedValue.length > 0) {
      return;
    }

    // If empty — load previous data
    if (this.invoicesearchedValue.length === 0) {
      this.invoicePageChange({ skip: 0, take: this.pageSize });
      this.getPaymentLinksList();
      return;
    }

    // Otherwise — run search
   this.getPaymentLinksList();
  }
  onSearchInvoicesAds(): void {
    this.triggerSearch();
    /* if (this.invoicesearchedValue.length > 0) {
      this.getPaymentLinksList();
    } */
  }

  getPaymentLinksList() {
    this.store.dispatch(
      getPaymentLink({
        pageIndex: this.invoicecurrentPage,
        pageSize: this.pageSize,
        searchTerm: this.invoicesearchedValue,
        projectId: this.currentUserData.project?.id,
        orderBy: this.orderByQuery,
        filter: this.queryString,
      })
    );
  }

  exportAll() {
    this.getAllPaymentlinksList();
  }
  public onExport(type: string) {
    if (this.paymentLinkgridData.data.length > 0) {
      if (type === 'Excel') {
        setTimeout(() => {
          this.hiddenGrid?.saveAsExcel();
        }, 1000);
      } else {
        this.sharedService.showMessageDialog(
          'No data to display',
          '',
          SweetAlertIcon.ERROR
        );
      }
    } else if (type === 'Pdf') {
      setTimeout(() => {
        this.hiddenGrid?.saveAsPDF();
      }, 1000);
    }
  }

  getAllPaymentlinksList() {
    this.store.dispatch(
      getAllPaymentlinksListExport({
        projectId: this.currentUserData?.project?.id,
        pageIndex: 1,
        pageSize: undefined,
        searchTerm: '',
        filter: '',
        orderBy: '',
      })
    );
  }
  public imageSrc: string | ArrayBuffer | null = null;
  handleFileSelected(event: any) {
    console.log(event);
    this.files = [];
    const newFiles = event.files.filter(
      (f: any) =>
        !this.files.find((existingFile) => existingFile.name == f.name)
    );
    this.files = [...this.files, ...newFiles];
    if (this.files) {
      const reader = new FileReader();
      reader.onload = (e) => (this.imageSrc = reader.result);
      reader.readAsDataURL(event.files[0].rawFile);
    }

    console.log(this.files);
  }
  public onRemove(event: RemoveEvent): void {
    console.log('File removed:', event.files);
    this.imageSrc = null;
    // You can add additional logic here, such as notifying the server or updating your UI state
  }
  handleFileRemoved(event: any) {
    console.log(event);
  }
  invoiceId: any;
  sendPaymentLink(type: string) {
    this.individualbillSubmitted = true;
    console.log(this.addpaymentLinkForm.value);
    if (this.addpaymentLinkForm.invalid) {
      return;
    } else {
      this.loaderService.setLoading(true);
      const flatData = this.addpaymentLinkForm.get('flatNo')?.value;
      let payloadData = {
        projectId: this.currentUserData?.project?.id,
        consumerId: this.addpaymentLinkForm.get('consumerId')?.value,
        amount: this.addpaymentLinkForm.get('rechargeamt')?.value,
        consumerName: this.addpaymentLinkForm.get('consumerName')?.value,
        email: this.addpaymentLinkForm.get('email')?.value,
        phoneNo: this.addpaymentLinkForm.get('contactNumber')?.value,
        residentialUnitId: flatData
          ? flatData['id']
          : '00000000-0000-0000-0000-000000000000',
        flatNo: flatData ? flatData['flatNo'] : '',
      };
      console.log(payloadData);
      this.paymentLinkService.createPaymentLinks(payloadData).subscribe({
        next: (response) => {
          // this.loaderService.setLoading(true);
          if (response && response.statusCode == 201) {
            this.sharedService.showMessageDialog(
              response.message,
              '',
              SweetAlertIcon.SUCCESS
            );
            this.getPaymentLinksList();
          } else {
            this.sharedService.showMessageDialog(
              response.message,
              '',
              SweetAlertIcon.ERROR
            );
          }
          this.loaderService.setLoading(false);
          console.log('Payment link created successfully:', response);
          this.invoiceAdd.hide();
          // Handle success (e.g., show success message or redirect)
        },
        error: (error) => {
          this.loaderService.setLoading(false);
          console.error('Failed to create payment link:', error);
          // Handle error (e.g., show error notification)
        },
      });
    }
  }

  deletdinvoiceAdd(dataItem: any): void {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-primary ms-2',
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        showCancelButton: true,
      })
      .then((result) => {
        if (result.value) {
          this.store.dispatch(deleteInvoice({ id: dataItem.id }));
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          swalWithBootstrapButtons.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }
  valueChange(value: any) {
    console.log(this.addpaymentLinkForm.controls['slot'].value);
    console.log(value);
  }
  selectedSlot: any;
  editInvoice(data: any, addInvoiceModal: any) {
    this.invoiceId = data?.id;
    let url = [
      {
        name: data.fileName,
        src: data.fileUrl,
        size: 1000,
        uid: 1,
      },
    ];
    this.imageSrc = url[0].src; // image preview upadted
    let dt = [];
    dt.push(new Date(data.from));
    dt.push(new Date(data.to));
    let slot_id = data.slot;
    //console.log(data.slot.)
    this.addpaymentLinkForm.controls['slot'].setValue(data.slot);
    this.addpaymentLinkForm.patchValue({
      date: dt,
      // slot: slot_id,
      projectId: data?.project?.id,
      files: url,
    });

    // console.log(this.addpaymentLinkForm.value);
    this.invoiceAdd = this.modalService.show(addInvoiceModal, {
      class: 'modal-dialog-centered',
    });
  }
  invoiceselectedRowdata: any = [];
  invoicedeselectedRowdata: any = [];

  public isRowSelected = (rowArg: any) => {
    return this.mySelection.some((row: any) => row.id === rowArg.id);
  };
  invoiceSelectforBillSetting(selection: any) {
    // Handle deselected rows
    selection.deselectedRows.forEach((row: any) => {
      const index = this.mySelection.findIndex(
        (selectedRow: any) => selectedRow.id === row.dataItem.id
      );
      if (index > -1) {
        this.mySelection.splice(index, 1);
      }
    });

    // Handle selected rows
    selection.selectedRows.forEach((row: any) => {
      if (!this.isRowSelected(row.dataItem)) {
        this.mySelection.push(row.dataItem);
      }
    });

    console.log(this.mySelection);
  }
  invoicecurrentPage: number = 1;
  protected invoicePageChange({ skip, take }: PageChangeEvent): void {
    this.mySelection = [];
    console.log('>>>', skip, take);
    this.skip = skip;
    this.pageSize = take;
    this.invoicecurrentPage = Math.floor(skip / take) + 1;
    console.log('currentpage', Math.floor(skip / take) + 1);
    this.getPaymentLinksList();
    this.loadBillsInvoiceGridTable();
  }

  protected invoicetateChange(state: DataStateChangeEvent): void {
    this.sort = state.sort || [];
    this.filter = state.filter || { logic: 'and', filters: [] };
    this.loadBillsInvoiceGridTable();
  }

  opemInvoiceModel(addInvoiceModal: any) {
    this.individualbillSubmitted = false;
    this.imageSrc = null;
    this.invoiceId = '';
    this.addpaymentLinkForm.reset();
    this.invoiceAdd = this.modalService.show(addInvoiceModal, {
      class: 'modal-dialog-centered',
      backdrop: 'static',
    });
  }

  onSortChange(sort: SortDescriptor[]): void {
    this.billsInvoice.sort = sort;
    console.log(this.billsInvoice.sort);
    const orderByQuery = this.sharedService.createOrderByQuery(
      this.billsInvoice.sort
    );
    this.orderByQuery = orderByQuery;

    this.getPaymentLinksList();
  }

  public customFilterState: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };
  customDateFiltersQueryEq: any[] = [];
  customDateFiltersQueryNEQ: any[] = [];
  async onInvoiceFilterChange(filter: CompositeFilterDescriptor) {
    this.billsInvoice.filter = filter;
    console.log(this.billsInvoice);

    this.customFilterState = {
      skip: 0,
      take: 10,
      filter: {
        logic: 'and',
        filters: [],
      },
    };
    this.customFilterState = _.cloneDeep(this.billsInvoice);
    var filterOperators = await this.sharedService.togetFilterOperators(
      this.billsInvoice
    );
    console.log('temp-------------->', filterOperators);
    const iscustomdates = filterOperators?.filter((filter: any) => {
      return filter.value instanceof Date;
    });

    let isEq: any;
    let isNeq: any;
    this.customDateFiltersQueryEq = [];
    this.customDateFiltersQueryNEQ = [];

    if (iscustomdates && iscustomdates.length > 0) {
      isEq = iscustomdates.filter((filter: any) => filter.operator === 'eq');
      isNeq = iscustomdates.filter((filter: any) => filter.operator === 'neq');

      if (isEq.length > 0) {
        this.customDateFiltersQueryEq =
          this.sharedService.customizeFilterQueryEQ(isEq);
        console.log('gasQueryString', this.customDateFiltersQueryEq);
      }
      if (isNeq?.length > 0) {
        isNeq.forEach((item: any) => {
          this.customDateFiltersQueryNEQ =
            this.sharedService.customizeFilterQueryNEQ(isNeq);
          console.log('gasQueryString', this.customDateFiltersQueryNEQ);
        });
      }
    } else {
      isNeq = undefined;
      isEq = undefined;
      this.customDateFiltersQueryEq = [];
      this.customDateFiltersQueryNEQ = [];
    }
    if (
      this.customDateFiltersQueryEq.length > 0 ||
      this.customDateFiltersQueryNEQ.length > 0
    ) {
      let customFilterQueryString =
        await this.sharedService.newmodifyFilterJson(
          this.customFilterState,
          this.customDateFiltersQueryEq,
          this.customDateFiltersQueryNEQ
        );
      this.queryString = this.sharedService.dateFiltercreateQuery(
        customFilterQueryString
      );
    } else {
      this.queryString = this.sharedService.createQuery(this.customFilterState);
    }

    const queryString = this.sharedService.createQuery(this.billsInvoice);
    // this.queryString = this.sharedService.createQuery(this.billsInvoice);
    this.getPaymentLinksList();
    console.log(queryString);
  }
}
